module.exports = __webpack_public_path__ + "img/no_data.0.1.0_202602021803.png";